import moment from "moment";

export const formatDate = (date, showTime = true, format?: string) => {
  if (date === null || date === undefined) return "-";

  // Özel format belirtilmişse onu kullan
  if (format) return moment.utc(date).local().format(format);

  if (showTime) return moment.utc(date).local().format("DD/MM/yyyy HH:mm:ss");

  return moment.utc(date).local().format("DD/MM/yyyy");
};
